<template>
  <div class="ui stackable grid">
      <div class="sixteen wide column">
      <ul>
        <li>Galleries</li>
        <li v-for="(gallery) in galleries" :key="gallery.id">
          {{gallery.id}} : {{gallery.name}}

          <ul>
            <li>Items</li>
            <li v-for="(item, index) in gallery.items" :key="index">
              {{item}}
            </li>
          </ul>
          <button class="circular ui icon button" @click="addItem(gallery)">add item</button>

        </li>
      </ul>
      <button class="circular ui icon button" @click="addGallery">add gallery</button>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Galleries',
  components: {
  },
    data() {
        return {
          items: {}
        };
    },
    mounted() {
        console.log(this.items);
    },
    computed: {
        ...mapGetters({
        galleries: 'GalleryModule/get'
      })
    },
    methods: {
        addGallery() {
          this.$store.dispatch('GalleryModule/create', {name: 'test', id: -1})
        },
        addItem(gallery) {
          this.$store.dispatch('GalleryModule/addItem', {gallery: gallery, name: 'test', id: -1})
        }
    }
}
</script>

<style scoped>
</style>
